import { EventWatchHandoff } from '../models/event-viewing.model';

const GUEST_PROVIDER_ALIAS = 'stream-viewer@attendee.citizex.invalid';

/** Presentation-only builder; it never turns a TODA URL into an authorization boundary. */
export function buildEventWatchUrl(
  todaOrigin: string,
  handoff: EventWatchHandoff,
  isGuest: boolean
): string {
  if (!handoff?.webinarId || !handoff?.providerAlias || !handoff?.providerPasscodeValue) {
    throw new Error('Event handoff is incomplete.');
  }
  if (isGuest && handoff.providerAlias !== GUEST_PROVIDER_ALIAS) {
    throw new Error('Guest event handoff is invalid.');
  }

  const base = todaOrigin.endsWith('/') ? todaOrigin : `${todaOrigin}/`;
  const streamOnly = handoff.mode === 'STREAM_ONLY';
  if (isGuest && !streamOnly) {
    throw new Error('Guest event handoff is invalid.');
  }
  if (!streamOnly && !handoff.publicName?.trim()) {
    throw new Error('Interactive event handoff is missing a verified public name.');
  }
  // Coresee's browser client is mounted at /events.  The similarly named
  // provider API uses a /webinar prefix, but navigating a browser there is
  // redirected to its invalid-url route.
  const route = `events/${encodeURIComponent(handoff.webinarId)}${streamOnly ? '/stream' : ''}`;
  const url = new URL(route, base);
  if (!streamOnly) {
    url.searchParams.set('name', handoff.publicName!.trim());
  }
  url.searchParams.set('email', handoff.providerAlias);
  url.searchParams.set('passcode', handoff.providerPasscodeValue);
  return url.toString();
}
